module.exports = "<button class=\"tab\"\r\n        ng-class=\"{active: $ctrl.isActive}\"\r\n        ng-click=\"$ctrl.onSelect({tab: $ctrl.activeTabId})\" translate>\r\n  Email Notifications\r\n</button>";


//////////////////
// WEBPACK FOOTER
// ./src/modules/email-notification-templates/components/email-notification-tab/components/tab-header/tab-header.html
// module id = 1289
// module chunks = 0